class InteractivePlayeraction {
  get type() {
    return 'playeraction'
  }

  getHtmlOutput() {
    return '<div class="player-action" style="display:none"></div>';
  }
}

export {InteractivePlayeraction}
